import { faArrowRight } from '@fortawesome/pro-solid-svg-icons/faArrowRight';
import { Icon } from '@osmosis/react-ui/components/Icon';
import { Button } from '@osmosis/react-ui/components/Button';
import { FormattedMessage } from 'react-intl';
import { useQuizContext } from '../../../../../context/QuizContext';
import { useUserContext } from '../../../../../context/UserContext';
import { useLearnAccess } from '../../../../../context/LearnAccessContext';
import { P } from '@osmosis/react-ui/components/Text';

const colorStyle = {
  color: 'gray60',
  ':hover': {
    color: 'primaryText',
  },
};

/**
 * SkipQuizButton.
 */
export const SkipQuizButton = () => {
  const { changeItem, currentIndex } = useQuizContext();
  const { user, hasPrime } = useUserContext();
  const { handleQuestionsAccess } = useLearnAccess();

  const clickHandler = () => {
    if ((user && hasPrime) || currentIndex < 1 || !user) {
      changeItem(1);
    } else if (user && !hasPrime) {
      handleQuestionsAccess();
    }
  };

  return (
    <Button
      data-testid="skip-quiz-btn"
      fontSize={2}
      variant={'transparent'}
      sx={{
        marginTop: 3,
        padding: '0',
        ':hover': {
          background: 'transparent',
        },
        ':active': {
          background: 'transparent',
        },
      }}
      onClick={clickHandler}
    >
      <P fontSize="15px" sx={colorStyle}>
        <FormattedMessage defaultMessage="Skip" id="skip-quiz-btn.text" />
        <Icon icon={faArrowRight} size="sm" style={{ marginLeft: '2px' }} />
      </P>
    </Button>
  );
};
